module.exports = __webpack_public_path__ + "media/packs/images/header-logo-77adccd7a764e920c41e1e3902b2e24b.svg";